import * as _ from "lodash";
import { Action, Field, FieldGroup, Pricing } from "../pricingListSlice";
import { isString } from "../../../common/utils/isString";
import { SelectedSite } from "../pricingList.model";

export const evaluatePropertyOnPricings = (forPricings: Pricing[], property?: string | boolean) => {
    const result = forPricings.every(
        (pricing) => {
            const path = property as string;
            if (path[0] == "!") {
                return !_.get(
                    pricing,
                    path.slice(1)
                );
            }
            return _.get(pricing, path);
        }
    );
    return result;
};

export const getFieldsMetadata = (forPricings: Pricing[], actionFields: {
    [key: string]: Field | FieldGroup;
} | undefined, action: Action | null | undefined) => {
    const metadatas: Record<string, { disabled: boolean; required: boolean; hidden: boolean }> = {};
    if (action) {
        _.toPairs(actionFields).forEach(([fieldName, field]) => {
            if (!field.is_array) {
                let required = false;
                let disabled = false;
                let hidden = false;
                if (field.required) {
                    if (isString(field.required)) {
                        required = evaluatePropertyOnPricings(forPricings, field.required);
                    } else {
                        required = !!field.required;
                    }
                }
                if (field.disabled) {
                    if (isString(field.disabled)) {
                        disabled = evaluatePropertyOnPricings(forPricings, field.disabled);
                    } else {
                        disabled = !!field.disabled;
                    }
                }
                if (field.hidden) {
                    if (isString(field.hidden)) {
                        hidden = evaluatePropertyOnPricings(forPricings, field.hidden);
                    } else {
                        hidden = !!field.hidden;
                    }
                }
                metadatas[fieldName] = { disabled, required, hidden };
            }
        });
    }
    return metadatas;
}


export function extractSites(pricings: Pricing[]): Record<string, SelectedSite> {
	const sites: SelectedSite[] = pricings
		.filter(
			(p) => p.site_pricings.length > 0 && p.site_pricings[0].timeserie
		)
		.map((p) => ({
			id: p.site_pricings[0].site.id,
			name: p.site_pricings[0].site.name,
			asset_id: p.site_pricings[0].site.asset_id,
			timeserie_id: p.site_pricings[0].timeserie.id,
		}));
	const uniqueSites: Record<string, SelectedSite> = {};
	sites.forEach((site) => {
		uniqueSites[site.asset_id] = site;
	});
	return uniqueSites;
}
